import * as Yup from 'yup';
import { validationMessages } from 'src/modules/common/types/constants';

export const getCreateReportValidationSchema = () => {
  return Yup.object().shape({
    title: Yup.string().required(validationMessages.required),
    year: Yup.string().required(validationMessages.required),
  });
};
